import React from 'react';
import { createPortal } from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles';

const useStyles = makeStyles(styles);

// a style tag because MUI v4 JSS cannot express @page
const PRINT_CSS = `
  @page { margin: 10mm; }
  @media screen { [data-print-root] { display: none; } }
  @media print {
    html, body { overflow: visible !important; height: auto !important; }
    body > *:not([data-print-root]) { display: none !important; }
  }
`;

const PrintView = ({ header, children }) => {
  const classes = useStyles();

  return createPortal(
    <div data-print-root className={classes.root}>
      <style>{PRINT_CSS}</style>
      {header}
      {children}
    </div>,
    document.body
  );
};

export default PrintView;
